import {
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useToast } from "@chakra-ui/react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ForgotPassword = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const toast = useToast();
  const navigate = useNavigate();

  const submitHandler = async () => {
    setLoading(true);
    if (!email) {
      toast({
        title: "Please enter your email",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
      return;
    }

    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const { data } = await axios.post(
        "/api/user/forgot-password",
        { email },
        config
      );

      toast({
        title: "Email Sent Successfully!",
        description: "Please check your email for the password reset token",
        status: "success",
        duration: 10000,
        isClosable: true,
        position: "bottom",
      });

      setEmailSent(true);
      setLoading(false);
    } catch (error) {
      const message = error.response
        ? error.response.data.message
        : error.message;
      toast({
        title: "Error Occurred!",
        description: message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
    }
  };

  const handleClose = () => {
    setEmail("");
    setEmailSent(false);
    onClose();
  };

  const handleGoToResetPage = () => {
    handleClose();
    navigate("/reset-password");
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Forgot Password</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {!emailSent ? (
            <VStack spacing="5px" color="black">
              <Text fontSize="md" mb={2}>
                Enter your email to receive a password reset token
              </Text>
              <FormControl id="email" isRequired>
                <FormLabel>Email:</FormLabel>
                <Input
                  placeholder="Enter Your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormControl>

              <Button
                colorScheme="blue"
                width="100%"
                style={{ marginTop: 15 }}
                onClick={submitHandler}
                isLoading={loading}
              >
                Send Reset Email
              </Button>
            </VStack>
          ) : (
            <VStack spacing="5px" color="black">
              <Text fontSize="lg" mb={2} fontWeight="bold" color="green.600">
                ✓ Email Sent Successfully!
              </Text>
              <Text fontSize="sm" mb={2} textAlign="center">
                We've sent a password reset link to <strong>{email}</strong>.
              </Text>
              <Text fontSize="sm" mb={2} textAlign="center" color="gray.600">
                Please check your email (including spam folder) and click the
                link to reset your password. The link will expire in 10 minutes.
              </Text>
              <Button
                colorScheme="blue"
                width="100%"
                style={{ marginTop: 15 }}
                onClick={handleClose}
              >
                Close
              </Button>
            </VStack>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ForgotPassword;
